import React, { lazy,Suspense } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { ToastContainer } from './utils/toast';
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer';
import PrivateRoute from './components/login/PrivateRoute';
import Loader from './components/loader/Loader';
import AuthGuard from './components/AuthGuard';
const Layout = lazy(() => import('./layout/Layout'));
const Login = lazy(() => import('./pages/Login'));
const SignUp = lazy(() => import('./pages/SignUp'));
const ForgetPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));

const App = () => {
  return (
    <>
      <ToastContainer />
      <Router>
        <AccessibleNavigationAnnouncer />
        <Suspense fallback={<Loader/>}>
        <Switch>
       
          <Route path="/login" component={Login} />
          <Route path="/signup" component={SignUp} />
          <Route path="/forgot-password" component={ForgetPassword} />
          <Route path="/reset-password/:token" component={ResetPassword} />

          <PrivateRoute>
            {/* {' '} */}
            {/* <AuthGuard redirectTo="/login"> */}
              <Route path="/" component={Layout} />
            {/* </AuthGuard> */}
          </PrivateRoute>
          {/* <Redirect exact from="/" to="/login" /> */}
        </Switch>
        </Suspense>
      </Router>
    </>
  );
};

export default App;

